import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-polyline",
  "use": "icon-polyline-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-polyline\">\n  <path d=\"M848 432a80.064 80.064 0 0 0-73.216 48H217.216A80.096 80.096 0 0 0 144 432 80.096 80.096 0 0 0 64 512c0 44.128 35.904 80 80 80A80 80 0 0 0 217.216 544h557.536a80 80 0 0 0 73.216 48c44.128 0 80-35.872 80-80a80.032 80.032 0 0 0-79.968-80z\" p-id=\"5033\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/polyline.svg
// module id = UibF
// module chunks = 12